/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMerchantTimecardAuthorization} from '../api'

 export const useQueryGetMerchantTimecardAuthorization = createReactQueryHook('getMerchantTimecardAuthorization', getMerchantTimecardAuthorization)
